import React from 'react';

function Footer(){

    return (
        <footer>
            Made with &#128151; by Ujjawal Sharma
        </footer>
    )

}

export default Footer;